export default __webpack_public_path__ + "0c35d18bf06992036b691da73d635fc4.woff2";